import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PREVIEWER_URL: string =
  import.meta.env['VITE_PREVIEWER_URL'] ?? 'https://see.tinct.ai';

/**
 * Share links minted before the previewer got its own app pointed at
 * `app.tinct.ai/demo/{organizationId}`. The dedicated app resolves that id
 * too, so the only thing to do is move the visitor there.
 */
export function LegacyOutreachDemoRedirect() {
  const { id = '' } = useParams<{ id: string }>();

  useEffect(() => {
    window.location.replace(
      `${PREVIEWER_URL.replace(/\/$/, '')}/${encodeURIComponent(id)}`,
    );
  }, [id]);

  return null;
}
